export default "__VITE_ASSET__DpmlTqHQ__"